import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { FaArrowLeft, FaCheck } from 'react-icons/fa';
import Swal from 'sweetalert2';
import styles from './Register.module.css'; 
import MensajeVerificacion from './MensajeVerificacion';

const RegisterTutor = () => {
    const navigate = useNavigate();
    
    // Estados para los campos del formulario
    const [nombre, setNombre] = useState('');
    const [mostrarVerificacion, setMostrarVerificacion] = useState(false);
    const [correoVerificacion, setCorreoVerificacion] = useState('');
    const [appa, setAppa] = useState('');
    const [apma, setApma] = useState('');
    const [telefono, setTelefono] = useState('');
    const [correo, setCorreo] = useState('');
    const [contrasenia, setContrasenia] = useState('');
    const [confcontrasenia, setConfContrasenia] = useState('');
    
    // Estado para errores
    const [errores, setErrores] = useState({
        contrasenia: '',
        telefono: '',
        correo: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        const nuevosErrores = { 
            contrasenia: '', 
            telefono: '', 
            correo: ''
        }; 

        let hayErrores = false; 

        // Validación de contraseña más robusta
        if (contrasenia !== confcontrasenia) {
            nuevosErrores.contrasenia = "La contraseña no coincide."; 
            hayErrores = true; 
        } else if (contrasenia.length < 8) {
            nuevosErrores.contrasenia = "La contraseña debe tener al menos 8 caracteres."; 
            hayErrores = true; 
        }
        // Validación de teléfono
        if (telefono.length < 10) {
            nuevosErrores.telefono = "El teléfono debe tener al menos 10 dígitos."; 
            hayErrores = true; 
        } else if (telefono.length > 14) {
            nuevosErrores.telefono = "El teléfono no debe exceder 14 dígitos."; 
            hayErrores = true; 
        }

        // Validación de correo
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(correo)) {
            nuevosErrores.correo = "El correo no es válido."; 
            hayErrores = true;  
        }

        setErrores(nuevosErrores); 

        if(!hayErrores) {
            const datosRegistro = { 
                nombre, 
                appa, 
                apma, 
                correo, 
                telefono, 
                contrasenia, 
                tipo_usuario: 3,
            }

            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/registro-tutor`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(datosRegistro),
                });

                if (!response.ok) {
                    const data = await response.json();
                    throw new Error(data.error || 'Error al registrar');
                }

                const data = await response.json();

                if (data.requiere_verificacion) {
                    setMostrarVerificacion(true);
                    setCorreoVerificacion(correo);
                } else {
                    Swal.fire({
                        title: 'Registro de tutor exitoso.', 
                        text: 'Se ha creado tu cuenta',
                        icon: 'success',
                        confirmButtonText: 'Continuar',
                        confirmButtonColor: '#242b57',
                        customClass: { popup: 'popupbonito' }
                    }).then(() => {
                        navigate('/signin');
                    }); 
                }
            } catch (error) {
                console.error('Error:', error); 
                Swal.fire({
                    title: 'Error', 
                    text: error.message || 'Ha ocurrido un error al registrar', 
                    icon: 'error', 
                    confirmButtonColor: '#242b57',
                    customClass: { popup: 'popupbonito' }
                }); 
                setErrores(prev => ({ 
                    ...prev, 
                    correo: error.message.includes('correo') ? error.message : prev.correo,
                })); 
            }
        }
    };

    const handleGoToLogin = () => { 
        navigate('/signin'); 
    }

    const validarContrasenia = (contrasenia, confirmacion) => { 
        if (!contrasenia) return '';
        
        if (confirmacion && contrasenia !== confirmacion) {
            return "Las contraseñas no coinciden.";
        }
        if (contrasenia.length < 8) {
            return "La contraseña debe tener al menos 8 caracteres.";
        }
        return '';
    }; 

    const validarEmail = (email) => { 
        if (!email) return ''; 
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(email)) {
            return "El correo no es válido.";
        }
        return ''; 
    }; 

    const handleChangeContrasenia = (e) => { 
        const valor = e.target.value; 
        setContrasenia(valor); 
        setErrores(prev => ({ 
            ...prev, 
            contrasenia : validarContrasenia(valor, confcontrasenia)
        })); 
    }

    const handleChangeConfContrasenia = (e) => { 
        const valor = e.target.value; 
        setConfContrasenia(valor); 
        setErrores(prev => ({ 
            ...prev, 
            contrasenia: validarContrasenia(contrasenia, valor) 
        })); 
    }; 

    const handleChangeCorreo = (e) => { 
        const valor = e.target.value; 
        setCorreo(valor); 
        setErrores(prev => ({
            ...prev, 
            correo: validarEmail(valor)
        })); 
    };

    return (
        <div className={styles.registroCuerpo}>
            <div className={styles.registroCuadro}>
                <div className={styles.headerRegistro}>
                    <button className={styles.botonLogin} onClick={handleGoToLogin}>
                        <FaArrowLeft className={styles.flechaLogin} />
                    </button>
                    <div className={styles.spacer}></div>
                </div>

                <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#242b57' }}>
                    Registro de Tutor
                </h2>

                <form onSubmit={handleSubmit} className={styles.registroForm}>
                    <label className={styles.registroLabel}>
                        Apellido paterno:
                        <input type="text" className={styles.inputForm}
                            value={appa} placeholder="Ingresa tu apellido paterno" 
                            onChange={(e) => setAppa(e.target.value)} required />
                    </label>

                    <label className={styles.registroLabel}>
                        Apellido materno:
                        <input type="text" className={styles.inputForm}
                            value={apma} placeholder="Ingresa tu apellido materno" 
                            onChange={(e) => setApma(e.target.value)} />
                    </label>

                    <label className={styles.registroLabel}>
                        Nombre (s):
                        <input type="text" className={styles.inputForm}
                            value={nombre} placeholder="Ingresa tu(s) nombre(s)" 
                            onChange={(e) => setNombre(e.target.value)} required />
                    </label>

                    <label className={styles.registroLabel}>
                        Teléfono de contacto:
                        <PhoneInput
                            country={'mx'} 
                            value={telefono}
                            onChange={(value) => {
                                const numeroLimpio = value.replace(/\D/g, '');
                                setTelefono(numeroLimpio);
                    
                                setErrores(prev => ({
                                    ...prev,
                                    telefono: numeroLimpio.length < 10 ? "El teléfono debe tener al menos 10 dígitos." : 
                                            (numeroLimpio.length > 14 ? "El teléfono no debe exceder 14 dígitos." : '')
                                }));
                            }}
                            inputClass={styles.inputTelefono}
                            containerClass={styles.phoneInputContainer}
                            placeholder="Ingresa tu teléfono de contacto"
                            preferredCountries={['mx', 'us', 'ca']}
                            enableSearch={true} 
                            searchPlaceholder="Buscar país..."
                            required
                        />
                    </label>
                    {errores.telefono && <p className={styles.mensajeError}>{errores.telefono}</p>}

                    <label className={styles.registroLabel}>
                        Correo electrónico:
                        <input type="email" className={styles.inputForm}
                            value={correo} placeholder="Ingresa tu correo" 
                            onChange={handleChangeCorreo} required />
                    </label>
                    {errores.correo && <p className={styles.mensajeError}>{errores.correo}</p>}

                    <div className={styles.registroCajaContrasenia}>
                        <label className={`${styles.registroLabel} ${styles.labelRequisitos}`}>
                            <p className={styles.requisitosTitulo}>La contraseña debe contar con al menos:</p>
                            <ul className={styles.listaRequisitos}>
                                <li><FaCheck className={styles.iconoCheck} /><span>8 Caracteres</span></li>
                            </ul>
                        </label>

                        <label className={`${styles.registroLabel} ${styles.campoContrasenia}`}>
                            Contraseña:
                            <input type="password" className={styles.inputForm}
                                value={contrasenia} placeholder="Ingresa contraseña segura" 
                                onChange={handleChangeContrasenia} required />
                        </label> 

                        <label className={`${styles.registroLabel} ${styles.campoContrasenia}`}>
                            Confirmar contraseña:
                            <input type="password" className={styles.inputForm}
                                value={confcontrasenia} placeholder="Ingresa de nuevo tu contraseña" 
                                onChange={handleChangeConfContrasenia} required />
                        </label>

                        {errores.contrasenia && <p className={styles.mensajeError}>{errores.contrasenia}</p>}
                    </div>

                    <button type="submit" className={styles.registroBoton}>Registrarse</button>
                </form>

                {mostrarVerificacion && ( 
                    <MensajeVerificacion
                        correo={correoVerificacion}
                        onCerrar={() => { 
                            setMostrarVerificacion(false); 
                            navigate('/signin');
                        }}
                    />
                )}
                
            </div>
        </div>
    );
};

export default RegisterTutor;